import * as React from 'react';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { uploadFile } from '../../../services/media.service';
import * as uuidv4 from 'uuid/v4';
import { MAX_UPLOAD_SIZE_BYTES, MAX_UPLOAD_STR } from '@nexxt/common/constants';

const acceptFormats = {
    image: 'image/jpeg, image/png, image/gif',
    video: 'video/mp4',
    // csv: "text/*",
    default: 'image/jpeg, image/png, image/gif, video/mp4, text/*'
};

class UploadMedia extends React.Component<any, any> {
    static defaultProps = {
        isMultiple: false,
        type: 'image'
    };

    upload = async (accepted, rejected) => {
        if (accepted.length > 0) {
            // Can add promises here and resolve afterwards
            try {
                await accepted.forEach(async (image) => {
                    const id = uuidv4(); // generate random ID
                    this.props.onUpload(id, 'uploading');

                    const notifyId = await new Promise((resolve) => {
                        this.props.notify(
                            `File uploading...`,
                            'info',
                            {},
                            (id) => {
                                resolve(id);
                            }
                        );
                    });
                    const response = await this.props.uploadFile(
                        image,
                        this.props.type
                    );
                    this.props.onUpload(
                        id,
                        'complete',
                        response?.path,
                        response?.filename
                    );
                    this.props.notify(`Upload completed!`, 'success');
                    this.props.notify(notifyId, 'remove');
                });
            } catch (e) {
                this.props.notify(`Error File upload`, 'error');
            }
        }

        if (rejected.length) {
            // show error message from here
        }
    };
    render() {
        const { props, upload } = this;
        return (
            <Dropzone
                accept={acceptFormats[props.type] || acceptFormats['default']}
                multiple={props.isMultiple}
                onDrop={upload}
                maxSize={MAX_UPLOAD_SIZE_BYTES}
                onDropRejected={() =>
                    this.props.notify(
                        `Unsupported file type or too large (cannot be larger than ${MAX_UPLOAD_STR}!`,
                        'error'
                    )
                }
                data-test="video-upload"
            >
                {({ getRootProps, getInputProps }: any) => (
                    <div
                        {...getRootProps()}
                        className={classnames(`upload-area`, {
                            'upload-only': props.isSingle
                        })}
                    >
                        <input {...getInputProps()} />
                        <>
                            <span className="upload-icon">
                                <i className="nx nx-upload"></i>
                            </span>
                            <span className="upload-input">
                                Drag and drop a file or{' '}
                                <label htmlFor="file">browse</label>
                            </span>
                        </>
                    </div>
                )}
            </Dropzone>
        );
    }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
    uploadFile: (acceptedFile: any, type: string) =>
        dispatch(uploadFile(acceptedFile, type))
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadMedia);
